import { takeLatest, put, select } from 'redux-saga/effects';
import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { SITE_ALIASES_GRID_NAME } from '../constants';

import { ACTION_LOAD_SITES_WITH_ALIASES__SUCCESS } from '../../site/actionTypes';

import { getModifiedLocationByFilter } from 'react-redux-app/lib/modules/queryFilter/utils';
import { getGridFilter } from '../utils';

import { getSitesWithAliasesOptions } from '../../site/selectors/sitesWithAliases';


function* checkFilter(history) {
  try {
    const filter = getGridFilter(history.location);
    const options = yield select(getSitesWithAliasesOptions);
    if (filter.siteId && !options.some(({ value }) => value === filter.siteId)) {
      filter.siteId = null;
      history.push(getModifiedLocationByFilter(history.location, SITE_ALIASES_GRID_NAME, filter));
    }
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga(history) {
  yield takeLatest([ACTION_LOAD_SITES_WITH_ALIASES__SUCCESS], checkFilter, history);
}
